<template>
    <money v-model="model"
             v-bind="$store.getters.money"
             class="form-control text-right"
             :required="required"
             :data-value="required"
             :disabled="disabled" />
</template>

<script>
export default {
  props: {
    value: null,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
